<div class="w-full mt-2">
  <div class="flex flex-col text-sm border-2 border-lighterText mb-2 rounded-2xl py-2 px-4 w-full">
    <span class="font-semibold text-base mb-2">1/3: KOMMUNIKATION</span>

    <div class="flex flex-col md:flex-row gap-4 h-full">
      <div class="w-full md:w-[75%] flex flex-col">
        <span>
          Ich willige ein, von {{ brand.name.toUpperCase() }} über die aufgeführten Kanäle Mitteilungen
          zu meinen Interessen und Präferenzen zu erhalten.
        </span>

        <div class="flex gap-4 items-center mt-4">
          <img src="assets/images/ic_angebote_active1x.png" class="w-14 h-14">
          <div class="flex flex-col gap-1">
            <span class="font-semibold">Relevante Angebote</span>
            <span>{{ getContactEvent('OFFERS').customerDescription | stripHtml }}</span>
          </div>
        </div>

        <div class="flex gap-4 items-center mt-4">
          <img src="assets/images/ic_erinnerungen_active1x.png" class="w-14 h-14">
          <div class="flex flex-col gap-1">
            <span class="font-semibold">Erinnerungen</span>
            <span>{{ getContactEvent('REMINDER').customerDescription | stripHtml }}</span>
          </div>
        </div>

        <div class="flex gap-4 items-center mt-6">
          <img src="assets/images/ic_events_active1x.png" class="w-14 h-14">
          <div class="flex flex-col gap-1">
            <span class="font-semibold">Einladungen</span>
            <span>{{ getContactEvent('EVENTS').customerDescription | stripHtml }}</span>
          </div>
        </div>

        <div class="flex gap-4 items-center mt-6">
          <img src="assets/images/ic_befragungen_active1x.png" class="w-14 h-14">
          <div class="flex flex-col gap-1">
            <span class="font-semibold">Befragungen</span>
            <span>{{ getContactEvent('SURVEYS').customerDescription | stripHtml }}</span>
          </div>
        </div>
      </div>

      <!-- CONTACT CHANNELS DESKTOP VIEW -->
      <div class="hidden md:block flex flex-col w-[25%] bg-buttonsBar/60 rounded-2xl justify-start items-center">
        <div class="w-full flex justify-center items-center">
          <span class="font-semibold text-base mt-4">KONTAKTKANÄLE</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center mt-4">
          <img src="assets/images/ic_post_active1x.png" class="w-14 h-14">
          <span class="font-semibold">Post</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center mt-4">
          <img src="assets/images/ic_mail_active1x.png" class="w-14 h-14">
          <span class="font-semibold">E-Mail</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center mt-4">
          <img src="assets/images/ic_phone_active1x.png" class="w-14 h-14">
          <span class="font-semibold">Telefon</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center mt-4 mb-2">
          <img src="assets/images/ic_messenger_active1x.png" class="w-14 h-14">
          <span class="font-semibold">Messenger / SMS</span>
        </div>
      </div>

      <!-- CONTACT CHANNELS MOBILE VIEW -->
      <div class="md:hidden flex flex-col w-full bg-buttonsBar/60 p-2 rounded-2xl justify-center items-center">
        <span class="font-semibold text-base">KONTAKTKANÄLE</span>

        <div class="flex w-full justify-between items-start mt-4 gap-1">
          <div class="flex flex-col gap-1 justify-center items-center w-full">
            <img src="assets/images/ic_post_active1x.png" class="w-14 h-14">
            <span class="font-semibold">Post</span>
          </div>

          <div class="flex flex-col gap-1 justify-center items-center w-full">
            <img src="assets/images/ic_mail_active1x.png" class="w-14 h-14">
            <span class="font-semibold">E-Mail</span>
          </div>

          <div class="flex flex-col gap-1 justify-center items-center w-full">
            <img src="assets/images/ic_phone_active1x.png" class="w-14 h-14">
            <span class="font-semibold">Telefon</span>
          </div>

          <div class="flex flex-col gap-1 justify-center items-center w-full min-w-[82px]">
            <img src="assets/images/ic_messenger_active1x.png" class="w-14 h-14">
            <span class="font-semibold text-center w-full">Messenger / SMS</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
